import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { projects } from "../../assets/projects";
import { getMediaSrc } from "../../components/helpers/preloadMedia";

const isVideo = (src) => /\.(mp4|webm)(\?|$)/i.test(src);

// content arrays mix prose strings with imported media; imported media
// resolves to a URL (or an inlined data: URI for small files).
const isMediaItem = (item) =>
  /^data:/.test(item) || /\.(png|jpe?g|webp|svg|mp4|webm)(\?|$)/i.test(item);

const ProjectPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const project = projects.find((p) => p.id === Number(id));

  const handleBack = () => {
    navigate("/");
  };

  if (!project) {
    return (
      <section className="project-page">
        <a onClick={handleBack} id="back-btn">
          Back
        </a>
        <h1>Project not found</h1>
      </section>
    );
  }

  const {
    title,
    description,
    type,
    technologies,
    link,
    year,
    mediaFiles,
    content,
  } = project;
  // Middle slot holds the main visual — show it first on the page.
  const [left, right, middle] = mediaFiles;
  // A project's optional content array (text and media, in any order)
  // defines the page body; without one, fall back to the hover media.
  const body = content?.length ? content : [];

  return (
    <section className="project-page">
      <a onClick={handleBack} id="back-btn">
        Back
      </a>
      <div>
        <h1>{title}</h1>
        <div className="project-meta">
          <p>
            {description} — {year}
          </p>
          {type && (
            <p>
              TYPE: <span className="meta-value">{type}</span>
            </p>
          )}
          {technologies && (
            <p>
              TECHNOLOGIES: <span className="meta-value">{technologies}</span>
            </p>
          )}
          {link && (
            <p className="project-link">
              LINK:{" "}
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link}
              </a>
            </p>
          )}
        </div>
        <div className="project-imgs">
          {body.map((item, index) => {
            if (typeof item === "string" && !isMediaItem(item)) {
              return <p key={index}>{item}</p>;
            }
            const src = typeof item === "string" ? item : item.src;
            const style = item.width ? { width: item.width } : undefined;
            return isVideo(src) ? (
              item.controls ? (
                // Player with native controls and sound (e.g. motion video)
                <video key={index} src={src} style={style} controls playsInline />
              ) : (
                <video
                  key={index}
                  src={src}
                  style={style}
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              )
            ) : (
              <img
                key={index}
                src={getMediaSrc(src)}
                alt={title}
                style={style}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProjectPage;
